import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { StyledSwitchWithLabel } from '../sideBarComponentsStyles';

interface SideBarSwitchWithLabelProps {
  label: string;
  checked: boolean;
  onChange: () => void;
}
export const SideBarSwitchWithLabel = ({
  label,
  checked,
  onChange
}: SideBarSwitchWithLabelProps) => {
  return (
    <StyledSwitchWithLabel
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <span className="label">{label}</span>
      <InputSwitch checked={checked} onChange={(e) => onChange()} />
    </StyledSwitchWithLabel>
  );
};
